module.exports = __webpack_public_path__ + "static/media/dashboardDetails_fr.1556638d.png";